import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  font-family: "Raleway", "sans-serif";
`;

export const InnerContainer = styled.div`
  padding: 30px 0 50px 20px !important;
  @media screen and (max-width: 767px) {
    padding: 30px 0 50px 0 !important;
  }
`;
